import { tr } from "../../i18n";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { LogOut } from "lucide-react";
import { api, apiError, useAuth } from "../../auth/AuthContext";
import { Card, fmtDate } from "../../components/portal";
import { Field, inputCls } from "../auth/AuthLayout";
export default function Account() {
  const {
    lang = "en"
  } = useParams();
  const navigate = useNavigate();
  const {
    logout
  } = useAuth();
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get("/client/profile").then(r => setForm(r.data)).catch(() => {});
  }, []);
  if (!form) return <p className="text-sm text-esaia-subtle">{tr("Loading...")}</p>;
  const set = k => e => setForm(f => ({
    ...f,
    [k]: e.target.value
  }));
  const save = async e => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch("/client/profile", form);
      toast.success(tr("Your account information has been updated."));
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSaving(false);
    }
  };
  return <div className="mx-auto max-w-3xl" data-testid="client-account">
      <h1 className="text-2xl font-semibold tracking-tight text-esaia-ink sm:text-3xl">{tr("My Account")}</h1>
      <p className="mt-1 text-sm text-esaia-muted">{tr("Account created")}{" "}{fmtDate(form.created_at)}</p>

      <div className="mt-8 space-y-6">
        <Card title={tr("Profile Information")} testid="account-profile">
          <form onSubmit={save} className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <Field label={tr("First name")} htmlFor="acc-first">
              <input id="acc-first" value={form.first_name} onChange={set("first_name")} className={inputCls} data-testid="account-first-name" />
            </Field>
            <Field label={tr("Last name")} htmlFor="acc-last">
              <input id="acc-last" value={form.last_name} onChange={set("last_name")} className={inputCls} data-testid="account-last-name" />
            </Field>
            <Field label={tr("Company")} htmlFor="acc-company">
              <input id="acc-company" value={form.company} onChange={set("company")} className={inputCls} data-testid="account-company" />
            </Field>
            <Field label={tr("Job title")} htmlFor="acc-title">
              <input id="acc-title" value={form.job_title} onChange={set("job_title")} className={inputCls} data-testid="account-job-title" />
            </Field>
            <Field label={tr("Email")} htmlFor="acc-email">
              <input id="acc-email" value={form.email} disabled className={`${inputCls} bg-esaia-surface text-esaia-subtle`} data-testid="account-email" />
            </Field>
            <Field label={tr("Phone")} htmlFor="acc-phone">
              <input id="acc-phone" value={form.phone} onChange={set("phone")} className={inputCls} data-testid="account-phone" />
            </Field>
            <Field label={tr("Country")} htmlFor="acc-country">
              <input id="acc-country" value={form.country} onChange={set("country")} className={inputCls} data-testid="account-country" />
            </Field>
            <div className="flex items-end">
              <button type="submit" disabled={saving} data-testid="account-save-button" className="bg-esaia-blue px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-esaia-dark disabled:opacity-60">
                {saving ? tr("Saving...") : tr("Save Changes")}
              </button>
            </div>
          </form>
        </Card>

        <Card title={tr("Security")} testid="account-security">
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link to={`/${lang}/change-password`} data-testid="account-change-password" className="inline-flex items-center justify-center border border-esaia-blue/40 px-5 py-2.5 text-sm font-semibold text-esaia-blue transition-colors hover:bg-esaia-blue hover:text-white">{tr("Change Password")}{" "}</Link>
            <button onClick={async () => {
            await logout();
            navigate(`/${lang}/login`);
          }} data-testid="account-logout-button" className="inline-flex items-center justify-center gap-2 border border-esaia-line px-5 py-2.5 text-sm font-semibold text-esaia-muted transition-colors hover:text-red-600">
              <LogOut size={15} />{" "}{tr("Log Out")}{" "}</button>
          </div>
        </Card>
      </div>
    </div>;
}
